import { Component } from 'react';
import withAuth from '../../components/withAuth';
import {compose} from "redux";
import {connect} from "react-redux";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AnalyseRisquesHeader from './AnalyseRisquesFormTabs/AnalyseRisquesHeader'
import AnalyseRisquesDetails from './AnalyseRisquesFormTabs/AnalyseRisquesDetails'
import AnalyseRisquesSignatures from './AnalyseRisquesFormTabs/AnalyseRisquesSignatures';
import AnalyseRisquesSecurity from './AnalyseRisquesFormTabs/AnalyseRisquesSecurity';
import AnalyseRisquesICP from './AnalyseRisquesFormTabs/AnalyseRisquesICP'
import AnalyseRisquesWorksNature from './AnalyseRisquesFormTabs/AnalyseRisquesWorksNature'
import AnalyseRisquesActionsForm from './AnalyseRisquesActionsForm'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import { submitOrEditAsDraft } from '../../redux/analyseRisques/analyseRisquesEditionActions'
import {arIsReadonly, isInError} from '../../redux/analyseRisques/analyseRisquesStatusActions'
import { redirect, setNbCompaniesDisplay } from '../../redux/analyseRisques/analyseRisquesActions'
import { loadSubcontractors } from '../../redux/tiers/tiersActions'
import './AnalyseRisquesForm.css';

class AnalyseRisquesForm extends Component {

    constructor(props){
        super(props);
        this.state={
            selectedTab: 0,
            analyseRisques: props.analyseRisques,
        }

        this.props.loadSubcontractors();
    }

    static getDerivedStateFromProps(nextProps, prevState){
        if(nextProps.redirectUrl !== null){
            nextProps.history.push(nextProps.redirectUrl);
            nextProps.resetRedirect();
        }

        //Sauvegarde en continue dans indexedb sauf si on a pas renseigné les infos capitales
        // d'une AR (Aka ot et affaire)
        if(nextProps.analyseRisques.header.numOt || nextProps.analyseRisques.header.ot
            || nextProps.analyseRisques.header.affair || nextProps.analyseRisques.header.affairInput)
            //Sauvegarde en continue dans indexedb
            nextProps.submitOrEditAsDraft(nextProps.analyseRisques, nextProps.activeUser, false, nextProps.analysesRisques.moduleSpp, nextProps.analysesRisquesState);

        return prevState
    }

    componentDidMount() {
        window.onbeforeunload = function(e) {
            e = e || window.event;

            // For IE and Firefox
            if (e) {
                e.returnValue = 'Refresh';
            }

            return "Refresh";
        };
    }

    submitOrEditAsDraft(){
        this.props.submitOrEditAsDraft(this.props.analyseRisques, this.props.activeUser, true, this.props.analysesRisques.moduleSpp, this.props.analysesRisquesState);
    }

    handleChange = (event, value) => {
        if (value === 3) {
            this.updateNbCompaniesDisplay();
        }
        this.setState({ selectedTab: value });
    };

    handleChangeIndex = index => {
        if (index === 3) {
            this.updateNbCompaniesDisplay();
        }
        this.setState({ selectedTab: index });
    };

    updateNbCompaniesDisplay = () => {
        let nbCompaniesDisplay = {...this.props.nbCompaniesDisplay}; 
        
        this.props.risks.forEach((risk) => {
            nbCompaniesDisplay[risk.id] = {};
            risk.solutions.forEach((solution) => {        
                let concernedCompanies = solution.concernedCompanies;
                var index = concernedCompanies.length - 1;
                for (var i = index ; i >= 0; i--) {
                    if (concernedCompanies[i].concerned) {
                        index = i;
                        break;
                    }
                }
                if (index < 1) {
                    index = 1;
                }
                if (!(solution.id in nbCompaniesDisplay[risk.id])) {
                    nbCompaniesDisplay[risk.id][solution.id] = index + 1;
                } 
            });
        });
        
        this.props.setNbCompaniesDisplay(nbCompaniesDisplay);
    }

    getJumbotronElement(){

        let message;

        if(isInError(this.props.analyseRisques.header.status)){
            let arOrPpsLabel = "Cette analyse de risques";

            if(this.props.analysesRisques.moduleSpp)
                arOrPpsLabel = "Ce plan de prévention simplifié"

            message = arOrPpsLabel + " est en erreur. Une action est requise sur"
            + " OpenERP pour corriger le problème. Lorsque ce sera fait, cliquez sur \"Synchroniser\"";
        }

        if(this.props.analyseRisques.header.validationInProgress){
            let arOrPpsLabel = "cette analyse de risques";

            if(this.props.analysesRisques.moduleSpp)
                arOrPpsLabel = "ce plan de prévention simplifié"

            message = "Une tentative de validation a été effectuée mais " +
            "il est possible qu'il y ait eu un problème réseau. Il n'est plus possible de modifier "
             + arOrPpsLabel + ". Veuillez cliquer sur le bouton \"Renvoyer validation\" pour continuer.";
        }

        if(message)
            return (
                <div className="jumbotron jumbotron-fluid jumbotron-information">
                    <div className="container">
                        <h1 className="display-6">Attention</h1>
                        <p className="lead">
                            {message}
                        </p>
                    </div>
                </div>
            )

        return (<div></div>);
    }

    render() {
        let tabs = [
            (<Tab key={0} label="Entête" />),
            (<Tab key={1} label="Nature des travaux" />),            
        ];

        let analyseRisquesTabs = [
            {
                tabContent: (<AnalyseRisquesHeader />),
                tabIsCard: true,
            },{
                tabContent: (<AnalyseRisquesWorksNature/>),
                tabIsCard: true,
            }
        ];

        if(this.props.analysesRisques.moduleSpp) {
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesICP/>)
            });
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesDetails/>)
            });
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesSecurity/>),
                tabIsCard: false,
            });
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesSignatures sppTab={true} />),
            });
            tabs.push((<Tab key={2} label="ICP" />));
            tabs.push((<Tab key={3} label="Risques" />));
            tabs.push((<Tab key={4} label="Sécurité" />));
            tabs.push((<Tab key={5} label="Signatures (PDP)" />));
        } else {
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesDetails/>)
            });
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesSecurity/>),
                tabIsCard: false,
            });
            analyseRisquesTabs.push({
                tabContent: (<AnalyseRisquesSignatures sppTab={false} />),
            });
            tabs.push((<Tab key={2} label="Risques" />));
            tabs.push((<Tab key={3} label="Sécurité" />));
            tabs.push((<Tab key={4} label="Signatures (AR)" />));
        }

        let analyseRisquesTabsHtml = [];

        analyseRisquesTabs.forEach((tab, index)=>{
            if(tab.tabIsCard){
                analyseRisquesTabsHtml.push(
                    <div key={index} className={(arIsReadonly(this.props.header) ? "disabled" : "") + " col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"}>
                        <div className="row">
                            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                                <CardContent>
                                    {tab.tabContent}
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                )
            }else{
                analyseRisquesTabsHtml.push(
                    <div key={index} className={(this.props.isCheckBeforeSubmitMode ? "disabled" : "") + " col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"}>
                        {tab.tabContent}
                    </div>
                )
            }
        })    
            

        let informationsJumbotronElement = this.getJumbotronElement();

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding margin-top">
                {informationsJumbotronElement}
                <AppBar position="static" color="default">
                    <Tabs value={this.state.selectedTab} variant="scrollable" scrollButtons="auto" onChange={this.handleChange}
                        indicatorColor="primary" textColor="primary">
                        {tabs}
                    </Tabs>
                </AppBar>
                <SwipeableViews axis='x' index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex}  className="margin-top container-with-footer">
                    {analyseRisquesTabsHtml}
                </SwipeableViews>
                <AnalyseRisquesActionsForm />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        header: state.analyseRisques.header,
        participants: state.analyseRisques.participants,
        raCompanies: state.analyseRisques.raCompanies,
        sppCompanies: state.analyseRisques.sppCompanies,
        risks: state.analyseRisques.risks,
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
        redirectUrl: state.analyseRisques.redirectUrl,
        isCheckBeforeSubmitMode: state.analyseRisques.header.checkBeforeSubmit,
        activeUser: state.activeUser,
        nbCompaniesDisplay: state.analyseRisques.nbCompaniesDisplay
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitOrEditAsDraft: (analyseRisques, activeUser, userAction, moduleSpp, analysesRisquesState) => dispatch(submitOrEditAsDraft(analyseRisques, activeUser, userAction, moduleSpp, analysesRisquesState)),
        resetRedirect: () => dispatch(redirect(null)),
        loadSubcontractors: () => dispatch(loadSubcontractors()),
        setNbCompaniesDisplay: (nbCompaniesDisplay) => dispatch(setNbCompaniesDisplay(nbCompaniesDisplay))
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesForm);
